import Cookies from 'js-cookie';

export function getCurrentLanguage() {
    const lang = Cookies.get('cl');

    return lang ? lang : 'se';
}

export function translateFromMap(map) {
    const lang = getCurrentLanguage();

    return map[lang] || map['se'];
}
